import {PlainDtoModel} from '../../../../common/entity/dto/plain/plainDto.model';
import {WithPermissionModel} from '../../../../common/permission/api/entity/withPermission.model';
import {SaleSummaryModel} from '../../../../sale/api/entity/saleSummary.model';
import {SALE_STATUS} from '../../../../sale/api/entity/sale.model';
import {SaleProductSummaryModel} from '../../../../sale/modules/product/api/entity/saleProductSummary.model';
import {ConsultationSummaryModel} from '../../../consultation/consultation/api/model/consultationSummary.model';

export class ChargedActModel extends WithPermissionModel implements PlainDtoModel {
    id: number;
    label: string;
    sale: SaleSummaryModel;
    consultation: ConsultationSummaryModel;
    products: SaleProductSummaryModel[] = [];
    comment: string;

    get signed() {
        if (this.sale?.purchaseOrders?.length > 0) {
            return this.sale.purchaseOrders[0].document.hasSignature;
        }
        return false;
    }

    get toBeSigned() {
        if (this.sale?.purchaseOrders?.length > 0) {
            return this.sale.purchaseOrders[0].document.toBeSigned;
        }
        return false;
    }

    resolveStatus(): string {
        switch (this.sale?.status.value) {
            case SALE_STATUS.SALE_STATUS_WAITING_CONFIRMATION:
                return 'Proposé au patient';
            case SALE_STATUS.SALE_STATUS_REFUSED:
                return 'Refusé par le patient';
            case SALE_STATUS.SALE_STATUS_COMPLETED:
                return 'Terminé';
        }
        return this.sale?.status?.label;
    }

    resolveColor(): string {
        return this.sale.resolveColor();
    }
}
